import {Component, EventEmitter, Input, Output} from "@angular/core";
import {NgClass} from "@angular/common";

export interface SegmentedToggleOption<T = string> {
  label: string
  value: T
}

@Component({
  selector: 'segmented-toggle',
  imports: [NgClass],
  templateUrl: './segmented-toggle.html'
})
export class SegmentedToggleComponent<T = string> {
  @Input('options') options: SegmentedToggleOption<T>[] = []
  @Input('selected') selected!: T
  @Output() selectedChange = new EventEmitter<T>()

  select(value: T) {
    if (value === this.selected) return
    this.selected = value
    this.selectedChange.emit(value)
  }
}
